<template>
  <Sheet>
    <img
      :src="MapGray"
      class="pointer-events-none absolute top-0 left-0 h-[180px] w-full object-cover"
    />
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #trailing>
      <Sheet.Button
        variant="primary"
        :icon="CheckmarkIcon"
        :disabled="!canSave"
        @click="proceed"
      />
    </template>

    <Sheet.Body class="px-0!">
      <div class="relative">
        <div
          class="pointer-events-none absolute top-0 left-0 h-[180px] w-full bg-gradient-to-b from-transparent to-white"
        />

        <div class="relative px-6 pt-2.5">
          <div class="mb-[34px] flex flex-col items-center">
            <h2
              class="mb-1.5 text-center text-[26px] font-medium leading-[34px] text-gray-800"
            >
              Register under national laws
            </h2>
            <p class="text-center text-[14px] leading-[22px] text-gray-800">
              Choose additional countries to have {{ workNoun }} recognized and
              registered under their copyright laws and applicable legal
              remedies.
            </p>
            <a
              href="https://help.dacr.com"
              target="_blank"
              class="mt-3 text-link text-[14px]"
            >
              Learn more and registration costs
            </a>
          </div>

          <div class="mb-[14px] text-[14px] leading-[22px] text-gray-600">
            Selected jurisdictions to be registered
          </div>

          <div class="grid grid-cols-2 items-center gap-2">
            <div
              v-for="origin in lockedOrigins"
              :key="origin.id"
              class="flex items-center gap-x-2 rounded-[22px] border-2 border-green-500 bg-green-200/20 py-1.5 pr-3 pl-1.5"
            >
              <div
                v-if="origin.id === 'Dacr'"
                class="flex size-[26px] items-center justify-center rounded-full border border-gray-600/15 bg-white"
              >
                <DacrMarkIcon class="size-[18px] text-gray-800" />
              </div>
              <Avatar v-else :src="origin.flag?.url" :size="26" />
              <div
                class="min-w-0 flex-1 truncate text-[13px] font-medium leading-[15px] text-gray-800"
              >
                {{ origin.name }}
              </div>
              <Checkbox
                :model-value="true"
                disabled
                class="pointer-events-none"
              />
            </div>

            <div
              v-for="origin in selectedOrigins"
              :key="origin.id"
              class="flex cursor-pointer items-center gap-x-2 rounded-[22px] border-2 border-green-500 bg-green-200/20 py-1.5 pr-3 pl-1.5"
              @click="toggleOrigin(origin.id)"
            >
              <Avatar :src="origin.flag?.url" :size="26" />
              <div
                class="min-w-0 flex-1 truncate text-[13px] font-medium leading-[15px] text-gray-800"
              >
                {{ origin.name }}
              </div>
              <Checkbox :model-value="true" class="pointer-events-none" />
            </div>
          </div>

          <template v-if="availableOrigins.length">
            <div
              class="mt-6 mb-[14px] text-[14px] leading-[22px] text-gray-600"
            >
              Other jurisdictions
            </div>

            <div class="grid grid-cols-2 items-center gap-2">
              <div
                v-for="origin in availableOrigins"
                :key="origin.id"
                class="flex cursor-pointer items-center gap-x-2 rounded-[22px] border border-black/8 bg-white py-1.5 pr-3 pl-1.5 transition-colors hover:border-black/15"
                @click="toggleOrigin(origin.id)"
              >
                <Avatar :src="origin.flag?.url" :size="26" />
                <div
                  class="min-w-0 flex-1 truncate text-[13px] font-medium leading-[15px] text-gray-800"
                >
                  {{ origin.name }}
                </div>
                <Checkbox :model-value="false" class="pointer-events-none" />
              </div>
            </div>
          </template>
        </div>
      </div>
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, Avatar, Checkbox, useSheet } from '@dacr/library'
import { DacrMarkIcon, CloseIcon, CheckmarkIcon } from '@dacr/icons'
import MapGray from '@/assets/images/MapGray.png'
import type { File } from '@/shared/graphql/router/graphql'
import { useRegisterCountries } from './useRegisterCountries'

const { close } = useSheet()

const props = defineProps<{
  files: File[]
}>()

const {
  lockedOrigins,
  selectedOrigins,
  availableOrigins,
  toggleOrigin,
  canSave,
  workNoun,
  proceed,
} = useRegisterCountries(props.files)
</script>
